import {
  ADS_CAMPAIGNS_TITLE,
  BRAND_INSIGHTS_PAGE_TITLE,
  AUTOMATIONS_MENU_TITLE,
  COMPETITOR_SCOPE_MENU_ITEM,
  GALLERY_TITLE,
  GLOBAL_REPORT_MENU_ITEM,
  SETTINGS_TITLE,
} from "../i18n/keysTranslations";
import {
  ROLES_ALLOWED,
  ROUTE_AUTOMATIONS,
  ROUTE_CAMPAIGNS,
  ROUTE_GALLERY,
  ROUTE_INSIGHTS,
} from "../utils/constants";
import ButtonOpenGallery from "../components/Buttons/ButtonOpenGallery";
import ButtonOpenCalendar from "../components/Buttons/ButtonOpenCalendar";
import ButtonOpenCompetitorScope from "../components/Buttons/ButtonOpenCompetitorScope";
import { Brain, Settings, Zap } from "lucide-react";
import { Marketing } from "../assets/svg/MenuIcons";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

const Menus = [
  {
    nameKey: "empty",
    roles: ROLES_ALLOWED,
    subMenus: [
      {
        nameKey: "ads-campaigns",
        name: ADS_CAMPAIGNS_TITLE,
        link: ROUTE_CAMPAIGNS,
        activePathPrefix: "/ads-campaign",
        roles: ROLES_ALLOWED,
        icon: <Marketing className="w-5 h-5" />,
      },
      {
        nameKey: "global-report",
        name: GLOBAL_REPORT_MENU_ITEM,
        link: "/report",
        roles: ROLES_ALLOWED,
        icon: (
          <AssessmentOutlinedIcon
            size={18}
            sx={{
              ml: "0px !important",
            }}
          />
        ),
      },
      {
        nameKey: "insights",
        name: BRAND_INSIGHTS_PAGE_TITLE,
        link: ROUTE_INSIGHTS,
        roles: ROLES_ALLOWED,
        icon: <Brain className="w-5 h-5" />,
        showUnreadBadge: true,
        newFeatureId: "insights",
      },
      {
        nameKey: "gallery",
        name: GALLERY_TITLE,
        link: ROUTE_GALLERY,
        roles: ROLES_ALLOWED,
        disabledSelectedStyle: true,
        customComponent: <ButtonOpenGallery />,
      },
      {
        nameKey: "competitor-scope",
        name: COMPETITOR_SCOPE_MENU_ITEM,
        roles: ROLES_ALLOWED,
        customComponent: <ButtonOpenCompetitorScope />,
      },
      {
        nameKey: "calendar",
        name: "calendar",
        roles: ROLES_ALLOWED,
        customComponent: <ButtonOpenCalendar />,
      },
      {
        nameKey: "automations",
        name: AUTOMATIONS_MENU_TITLE,
        link: ROUTE_AUTOMATIONS,
        roles: ROLES_ALLOWED,
        icon: <Zap size={18} />,
        newFeatureId: "automations",
      },
      {
        nameKey: "settings",
        name: SETTINGS_TITLE,
        link: "/settings",
        roles: ROLES_ALLOWED,
        icon: <Settings size={18} />,
        isPinnedBottom: true,
        disabledSelectedStyle: true,
      },
    ],
  },
];
export default Menus;
